import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_179_1873)">
      <mask
        id="mask0_179_1873"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="19"
      >
        <path
          d="M9 18.5C13.9706 18.5 18 14.4706 18 9.5C18 4.52944 13.9706 0.5 9 0.5C4.02944 0.5 0 4.52944 0 9.5C0 14.4706 4.02944 18.5 9 18.5Z"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_179_1873)">
        <path
          d="M21.0501 -3.41278H-2.77734V20.4147H21.0501V-3.41278Z"
          fill="#A1723A"
        />
        <g filter="url(#filter0_f_179_1873)">
          <path
            d="M9.68737 18.1215C14.9915 18.1215 19.2913 13.8229 19.2913 8.52039C19.2913 3.21782 14.9915 -1.08075 9.68737 -1.08075C4.38331 -1.08075 0.0834961 3.21782 0.0834961 8.52039C0.0834961 13.8229 4.38331 18.1215 9.68737 18.1215Z"
            fill="#531002"
          />
        </g>
        <g filter="url(#filter1_f_179_1873)">
          <path
            d="M10.7226 15.0825C15.0246 15.0825 18.5121 11.5938 18.5121 7.29034C18.5121 2.98679 15.0246 -0.501892 10.7226 -0.501892C6.42068 -0.501892 2.93323 2.98679 2.93323 7.29034C2.93323 11.5938 6.42068 15.0825 10.7226 15.0825Z"
            fill="#2B5DF0"
          />
        </g>
        <g filter="url(#filter2_f_179_1873)">
          <path
            d="M10.5807 15.5278C15.0656 15.5278 18.7013 11.8908 18.7013 7.4044C18.7013 2.91796 15.0656 -0.718994 10.5807 -0.718994C6.0958 -0.718994 2.46008 2.91796 2.46008 7.4044C2.46008 11.8908 6.0958 15.5278 10.5807 15.5278Z"
            fill="url(#paint0_radial_179_1873)"
          />
        </g>
        <g filter="url(#filter3_f_179_1873)">
          <path
            d="M11.9276 9.44993C14.187 9.44993 16.0185 7.61839 16.0185 5.35904C16.0185 3.09969 14.187 1.26813 11.9276 1.26813C9.66821 1.26813 7.83667 3.09969 7.83667 5.35904C7.83667 7.61839 9.66821 9.44993 11.9276 9.44993Z"
            fill="#FCB8D4"
          />
        </g>
        <g filter="url(#filter4_f_179_1873)">
          <path
            d="M11.9248 6.98982C12.8271 6.98982 13.5584 6.25846 13.5584 5.35624C13.5584 4.45404 12.8271 3.72266 11.9248 3.72266C11.0226 3.72266 10.2913 4.45404 10.2913 5.35624C10.2913 6.25846 11.0226 6.98982 11.9248 6.98982Z"
            fill="white"
          />
        </g>
        <g filter="url(#filter5_f_179_1873)">
          <path
            d="M10.8395 21.667C18.9471 21.667 25.5195 15.0946 25.5195 6.98704C25.5195 -1.12047 18.9471 -7.69293 10.8395 -7.69293C2.73199 -7.69293 -3.84045 -1.12047 -3.84045 6.98704C-3.84045 15.0946 2.73199 21.667 10.8395 21.667Z"
            fill="url(#paint1_radial_179_1873)"
            fill-opacity="0.9"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_f_179_1873"
        x="-3.89229"
        y="-5.05653"
        width="27.1593"
        height="27.1538"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="1.98789"
          result="effect1_foregroundBlur_179_1873"
        />
      </filter>
      <filter
        id="filter1_f_179_1873"
        x="-5.01836"
        y="-8.45348"
        width="31.482"
        height="31.4876"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="3.9758"
          result="effect1_foregroundBlur_179_1873"
        />
      </filter>
      <filter
        id="filter2_f_179_1873"
        x="-0.521771"
        y="-3.70085"
        width="22.2049"
        height="22.2105"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="1.49093"
          result="effect1_foregroundBlur_179_1873"
        />
      </filter>
      <filter
        id="filter3_f_179_1873"
        x="1.87298"
        y="-4.69556"
        width="20.1091"
        height="20.1092"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="2.98184"
          result="effect1_foregroundBlur_179_1873"
        />
      </filter>
      <filter
        id="filter4_f_179_1873"
        x="6.31547"
        y="-0.253129"
        width="11.2188"
        height="11.2187"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="1.98789"
          result="effect1_foregroundBlur_179_1873"
        />
      </filter>
      <filter
        id="filter5_f_179_1873"
        x="-6.82231"
        y="-10.6748"
        width="35.3237"
        height="35.3236"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="1.49093"
          result="effect1_foregroundBlur_179_1873"
        />
      </filter>
      <radialGradient
        id="paint0_radial_179_1873"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(11.9504 5.11263) rotate(128.228) scale(15.3367 15.3355)"
      >
        <stop offset="0.286458" stop-color="#387AFA" />
        <stop offset="0.647782" stop-color="#387AFA" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_179_1873"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(10.8395 6.98704) rotate(90) scale(14.68)"
      >
        <stop offset="0.598958" stop-opacity="0" />
        <stop offset="0.671875" />
        <stop offset="0.734375" stop-opacity="0" />
      </radialGradient>
      <clipPath id="clip0_179_1873">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
)
